import React from 'react';

import { useTranslation } from 'react-i18next';


const Notifications = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <h1> {t("Notifications")} </h1>
            <p>Notifications (messages) list....(?) </p>
            <ul>
                <li><a href=''>Notifications -1 </a> Notifications -1 </li>
                <li><a href=''>Notifications -2</a> Notifications -2</li>
                <li><a href=''>Notifications -3</a> Notifications -3</li>
                <li><a href=''>Notifications -4</a> Notifications -4</li>
                <li><a href=''>Notifications -5</a> Notifications -5</li>
            </ul>

        </div>
    );
}

export default Notifications;